
const DashboardIcon = ({ color = "var(--primary-color)", width, height, ...props}) => (
    <svg    
        viewBox="0 0 20 20"
        width={width || 20}
        height={height || 20}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        {...props}
    >
        <path
        stroke={`${color}`}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M6.333 2.365a2 2 0 0 1 2 2v2.667a2 2 0 0 1-2 2H3.667a2 2 0 0 1-2-2V4.365a2 2 0 0 1 2-2h2.666Z"
        clipRule="evenodd"
    />
    <path
        stroke={`${color}`}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M1.667 14.865A3.333 3.333 0 0 1 5 11.532a3.385 3.385 0 0 1 3.333 3.336 3.333 3.333 0 1 1-6.666-.003"
    />
    <path
        stroke={`${color}`}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M16.333 2.365a2 2 0 0 1 2 2V16.2a2 2 0 0 1-2 2h-3.5a2 2 0 0 1-2-2V4.365a2 2 0 0 1 2-2h3.5Z"
        clipRule="evenodd"
    />
    </svg>
)

export default DashboardIcon
